import React from "react";
import { useRef } from "react";
import StreamingWidgetToggler from "../streaming/StreamingWidgetToggler/StreamingWidgetToggler";

export default function BetradarWidget(props) {
    const ref = useRef(null);

    return (
        <>
            <StreamingWidgetToggler widgetContainerRef={ref}
                                    widgetContainerId={props.id}
                                    matchId={props.matchId}
                                    streamingComponent={props.streamingComponent}
                                    streamingContainer={props.streamingContainer}
                                    streaming={props.streaming}
                                    toggleStreaming={props.toggleStreaming}
                                    resetStreaming={props.resetStreaming}
                                    mainContext={props.mainContext}
            />
            <div ref={ref} className={props.className} id={props.id}></div>
        </>
       
    )
}
